import { ActionRow } from '@types'

const getActionIdentityKey = ({ eventCode, actionCode }: ActionRow) => `${eventCode}::${actionCode}`

export const mergeRedifinitionActions = (
  baseActions: ActionRow[] = [],
  redifinitionActions: ActionRow[] = []
) => {
  if (!redifinitionActions.length) {
    return baseActions
  }

  const redifinitionIdentityKeys = new Set(redifinitionActions.map(getActionIdentityKey))
  const filteredBaseActions = baseActions.filter(
    action => !redifinitionIdentityKeys.has(getActionIdentityKey(action))
  )

  return [...filteredBaseActions, ...redifinitionActions]
}
